import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const HomeHotKeyword = () => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const [keywordList, setKeywordList] = useState([]);

	useEffect(() => {
		let list = reduxChannel?.topSearchedList;
		setKeywordList(list);
	}, [reduxChannel]);

	const LinkTo = (item) => {
		let category = "";
		let link = "/together/channel/";
		if (item.is_show) {
			if (item.main_category === 0) {
				category = "ingredients/detail/" + item.category_id;
			} else if (item.main_category === 1) {
				category = "functions/detail/" + item.category_id;
			} else {
				category = "combinations/detail/" + item.sub_category;
			}
			link += category + "?id=" + reduxChannel.influencer_id;
			return link;
		}
	};

	return (
		<div className={`home-body home-each home-link-connection`}>
			{/* ${reduxChannel?.user_id !== 7 ? "" : "home-each-by-quick"}*/}
			{keywordList?.length > 0 && (
				<div className={`home-images-group max-width-apply`}>
					{/*${reduxChannel?.user_id !== 7 ? "keyword-border" : ""}*/}
					<div className={`home-recommend-horizontal`}>
						<div className={`recommend-title`}>
							{reduxChannel?.user_id !== 7 ? (
								<p className={`type-kr`}>많이 찾는 정보</p>
							) : (
								<p className={`type-kr`}>인기 검색어</p>
							)}
							<p className={`title`}>
								이번 주 사람들이{"\n"}
								가장 많이 검색한 키워드는?
							</p>
						</div>
						<div className={`home-hot-keywords-div`}>
							{keywordList.map((item, idx) => (
								<Link
									// onClick={(e) => {
									//     if (!item.is_show) {
									//         e.preventDefault();
									//         alert("해당 페이지는 수정중입니다.")
									//     }
									// }}
									to={`${LinkTo(item)}`}
									className={`hot-keyword-each`}
									key={`keyword-list-${idx}`}
								>
									<div className={`keyword-number`}>{idx + 1}위</div>
									<div className={`keyword-content`}>
										<span>{item?.display_word}</span>
										<img
											src={`/assets/images/channel/right-arrow.png`}
											alt={`화살표`}
											style={{
												height: "1.3em",
												width: "1.3em",
											}}
										/>
									</div>
								</Link>
							))}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
export default HomeHotKeyword;
